function _stripSalesforceCampaignPrefix(name) {
  const s = String(name || '').trim()
  const prefix = 'salesforce.campaign.'
  if (!s.startsWith(prefix)) return null
  const rest = s.slice(prefix.length)
  if (!rest) return null
  const parts = rest.split('.')
  if (parts.length >= 2) {
    const last = parts[parts.length - 1]
    if (/^[a-f0-9]{6,40}$/i.test(last)) {
      return parts.slice(0, -1).join('.')
    }
  }
  return rest
}

export function _titleizeToken(token: string): string {
  const s = String(token || '').trim()
  if (!s) return ''
  return s
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (m) => m.toUpperCase())
}

export function formatSignalBaseName(signal: Record<string, any>): any {
  const name = String(signal?.name || '').trim()
  const desc = signal?.description

  const sf = _stripSalesforceCampaignPrefix(name)
  if (sf) {
    if (desc && typeof desc === 'object') {
      if (typeof desc.signal_label === 'string' && desc.signal_label.trim()) {
        return desc.signal_label.trim()
      }
      if (typeof desc.campaign_name === 'string' && desc.campaign_name.trim()) {
        return desc.campaign_name.trim()
      }
    }
    return sf
  }

  if (desc && typeof desc === 'object' && typeof desc.signal_label === 'string' && desc.signal_label.trim()) {
    const label = desc.signal_label.trim()
    // If the label contains underscores, titleize it
    if (label.includes('_')) {
      return _titleizeToken(label)
    }
    return label
  }

  if (name.startsWith('warmly.')) {
    return _titleizeToken(name.slice('warmly.'.length))
  }

  if (name.includes('_')) {
    return _titleizeToken(name)
  }

  if (!name) return 'Signal'
  return name
}

function extractSignalPerson(description: any): any {
  const d = description
  if (!d || typeof d !== 'object') return ''

  const directName = typeof d.contact_name === 'string' ? d.contact_name.trim() : ''
  if (directName) return directName

  const directEmail = typeof d.contact_email === 'string' ? d.contact_email.trim() : ''
  if (directEmail) return directEmail

  const cm = d.campaign_member
  if (cm && typeof cm === 'object') {
    const c = cm.Contact
    if (c && typeof c === 'object') {
      const n = typeof c.Name === 'string' ? c.Name.trim() : ''
      if (n) return n
      const e = typeof c.Email === 'string' ? c.Email.trim() : ''
      if (e) return e
    }
  }

  const warmlyFirst = typeof d['First Name'] === 'string' ? d['First Name'].trim() : ''
  const warmlyLast = typeof d['Last Name'] === 'string' ? d['Last Name'].trim() : ''
  const warmlyFull = `${warmlyFirst} ${warmlyLast}`.trim()
  if (warmlyFull) return warmlyFull

  const warmlyEmail = typeof d['Business Email'] === 'string' ? d['Business Email'].trim() : (typeof d.Email === 'string' ? d.Email.trim() : '')
  if (warmlyEmail) return warmlyEmail

  return ''
}

export function extractSignalExtra(description) {
  const d = description
  if (!d || typeof d !== 'object') return ''

  const candidates = [
    d['Page URL'],
    d['Visited URL'],
    d['URL'],
    d['Page'],
    d['Landing Page'],
    d['Website'],
    d.Website,
    d.domain,
  ]

  for (const v of candidates) {
    if (typeof v === 'string' && v.trim()) return v.trim()
  }

  return ''
}

export function formatSignalHeadline(signal: any): string {
  const base = formatSignalBaseName(signal)
  const desc = signal?.description
  const person = extractSignalPerson(desc)
  const extra = extractSignalExtra(desc)

  const parts = [base]
  if (person) parts.push(person)
  if (extra) parts.push(extra)
  return parts.join(' • ')
}
